jQuery(function () {
  var selectors = {
    container: "[data-behaviour~=editable-card]",

    info: "[data-behaviour~=editable-card-info]",
    fields: "[data-behaviour~=editable-card-fields]",

    edit: "[data-behaviour~=editable-card-edit]",
    cancel: "[data-behaviour~=editable-card-cancel]",

    unsaved: "[data-unsaved-editable-card=true]",
  };

  jQuery(document).on("click", selectors.edit, function (e) {
    var container = jQuery(this).closest(selectors.container);

    container.find(selectors.fields).show();
    container.find(selectors.info).hide();
  });

  jQuery(document).on("click", selectors.cancel, function (e) {
    var container = jQuery(this).closest(selectors.container);
    var $targets = jQuery("nested-insert-target");
    if ($targets.length === 0) {
      jQuery(".empty-message-view").removeClass("--hidden");
    }
    if (container.data("unsaved-editable-card")) {
      container.remove();
    } else {
      container.find(selectors.fields).hide();
      container.find(selectors.info).show();
    }
  });
});
